module.exports = __webpack_public_path__ + "img/5-sdg-border@2x.0398b1d0.png";